export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "ar-AE": {
        "copy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["نسخ"])}
        },
        "copied": {
          "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تم النسخ إلى الحافظة"])}
        }
      },
      "ar-EG": {
        "copy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["نسخ"])}
        },
        "copied": {
          "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تم النسخ إلى الحافظة"])}
        }
      },
      "ar-SA": {
        "copy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["نسخ"])}
        },
        "copied": {
          "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تم النسخ إلى الحافظة"])}
        }
      },
      "el-GR": {
        "copy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Αντιγραφή"])}
        },
        "copied": {
          "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Αντιγράφηκε στο πρόχειρο"])}
        }
      },
      "el-CY": {
        "copy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Αντιγραφή"])}
        },
        "copied": {
          "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Αντιγράφηκε στο πρόχειρο"])}
        }
      },
      "de-DE": {
        "copy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kopieren"])}
        },
        "copied": {
          "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["In die Zwischenablage kopiert"])}
        }
      },
      "de-AT": {
        "copy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kopieren"])}
        },
        "copied": {
          "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["In die Zwischenablage kopiert"])}
        }
      },
      "de-CH": {
        "copy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kopieren"])}
        },
        "copied": {
          "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["In die Zwischenablage kopiert"])}
        }
      },
      "en-US": {
        "copy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Copy"])}
        },
        "copied": {
          "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Copied to clipboard"])}
        }
      },
      "en-GB": {
        "copy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Copy"])}
        },
        "copied": {
          "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Copied to clipboard"])}
        }
      },
      "it-IT": {
        "copy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Copia"])}
        },
        "copied": {
          "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Copiato negli appunti"])}
        }
      },
      "fr-FR": {
        "copy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Copier"])}
        },
        "copied": {
          "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Copié dans le presse-papier"])}
        }
      },
      "es-ES": {
        "copy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Copiar"])}
        },
        "copied": {
          "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Copiado al portapapeles"])}
        }
      },
      "pl-PL": {
        "copy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Skopiuj"])}
        },
        "copied": {
          "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Skopiowane do schowka"])}
        }
      },
      "nl-NL": {
        "copy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kopiëren"])}
        },
        "copied": {
          "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Gekopieerd naar klembord"])}
        }
      },
      "bg-BG": {
        "copy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Копиране"])}
        },
        "copied": {
          "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Копирано в клипборда"])}
        }
      },
      "bs-BA": {
        "copy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kopiraj"])}
        },
        "copied": {
          "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kopirano u međuspremnik"])}
        }
      },
      "da-DK": {
        "copy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kopier"])}
        },
        "copied": {
          "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kopieret til udklipsholderen"])}
        }
      },
      "et-EE": {
        "copy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kopeeri"])}
        },
        "copied": {
          "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kopeeritud lõikelauale"])}
        }
      },
      "fi-FI": {
        "copy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kopioi"])}
        },
        "copied": {
          "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kopioitu leikepöydälle"])}
        }
      },
      "he-IL": {
        "copy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["עותק"])}
        },
        "copied": {
          "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["הועתק ללוח"])}
        }
      },
      "ga-IE": {
        "copy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cóipeáil"])}
        },
        "copied": {
          "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cóipeáladh chuig an ngearrthaisce é"])}
        }
      },
      "ja-JP": {
        "copy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["コピー"])}
        },
        "copied": {
          "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["クリップボードにコピー"])}
        }
      },
      "hr-HR": {
        "copy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kopiraj"])}
        },
        "copied": {
          "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kopirano u međuspremnik"])}
        }
      },
      "lv-LV": {
        "copy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kopēt"])}
        },
        "copied": {
          "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nokopēts starpliktuvē"])}
        }
      },
      "lt-LT": {
        "copy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kopijuoti"])}
        },
        "copied": {
          "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nukopijuota į mainų sritį"])}
        }
      },
      "pt-PT": {
        "copy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Copiar"])}
        },
        "copied": {
          "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Copiado para a área de transferência"])}
        }
      },
      "ro-RO": {
        "copy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Copiere"])}
        },
        "copied": {
          "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Copiat în clipboard"])}
        }
      },
      "ru-RU": {
        "copy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Скопировать"])}
        },
        "copied": {
          "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Скопировано в буфер обмена"])}
        }
      },
      "sv-SE": {
        "copy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kopiera"])}
        },
        "copied": {
          "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kopieras till Urklipp"])}
        }
      },
      "sk-SK": {
        "copy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kópia"])}
        },
        "copied": {
          "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Skopírované do schránky"])}
        }
      },
      "cs-CZ": {
        "copy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kopírovat"])}
        },
        "copied": {
          "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zkopírováno do schránky"])}
        }
      },
      "hu-HU": {
        "copy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Másol"])}
        },
        "copied": {
          "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["A vágólapra másolva"])}
        }
      },
      "fr-BE": {
        "copy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Copier"])}
        },
        "copied": {
          "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Copié dans le presse-papier"])}
        }
      },
      "fr-LU": {
        "copy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Copier"])}
        },
        "copied": {
          "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Copié dans le presse-papier"])}
        }
      },
      "mt-MT": {
        "copy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ikkopja"])}
        },
        "copied": {
          "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ikkoppjat fuq il-klibbord"])}
        }
      },
      "sl-SI": {
        "copy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kopiraj"])}
        },
        "copied": {
          "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kopirano v odložišče"])}
        }
      },
      "tr-TR": {
        "copy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kopyala"])}
        },
        "copied": {
          "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Panoya kopyalandı"])}
        }
      },
      "tr-CY": {
        "copy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kopyala"])}
        },
        "copied": {
          "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Panoya kopyalandı"])}
        }
      },
      "uk-UA": {
        "copy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kopieren"])}
        },
        "copied": {
          "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["In die Zwischenablage kopiert"])}
        }
      },
      "zh-CN": {
        "copy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["复制"])}
        },
        "copied": {
          "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["复制到剪贴板"])}
        }
      }
    }
  })
}
